var map = {
	"./fonts/Rubik.woff2": 91455,
	"./icons/activity.svg": 2432,
	"./icons/alert-triangle.svg": 52348,
	"./icons/align-left.svg": 50752,
	"./icons/archive.svg": 39363,
	"./icons/arrow-down.svg": 31759,
	"./icons/arrow-left.svg": 65648,
	"./icons/arrow-right.svg": 76415,
	"./icons/arrow-up.svg": 46688,
	"./icons/arrow.svg": 57190,
	"./icons/bank.svg": 73209,
	"./icons/bar-chart-2.svg": 55036,
	"./icons/bell.svg": 73516,
	"./icons/book-open.svg": 69429,
	"./icons/box.svg": 2474,
	"./icons/calculate.svg": 50041,
	"./icons/calendar.svg": 85033,
	"./icons/camera.svg": 58854,
	"./icons/card.svg": 94817,
	"./icons/cash.svg": 52442,
	"./icons/check-square.svg": 4723,
	"./icons/check.svg": 82497,
	"./icons/check2.svg": 26721,
	"./icons/chevron-down.svg": 79573,
	"./icons/chevron-down2.svg": 11421,
	"./icons/chevron-right.svg": 19501,
	"./icons/clock.svg": 92075,
	"./icons/close-2.svg": 51452,
	"./icons/close.svg": 35837,
	"./icons/copy.svg": 28552,
	"./icons/corner-down-right.svg": 44692,
	"./icons/credit-card.svg": 48531,
	"./icons/credit.svg": 60552,
	"./icons/creditcheck.svg": 72560,
	"./icons/crop.svg": 76217,
	"./icons/device.svg": 10781,
	"./icons/device2.svg": 59541,
	"./icons/deviceIcon.svg": 60378,
	"./icons/divide.svg": 95004,
	"./icons/download.svg": 91303,
	"./icons/download2.svg": 79047,
	"./icons/drag.svg": 37229,
	"./icons/droplet.svg": 36935,
	"./icons/duplicate.svg": 20430,
	"./icons/dyna.svg": 1309,
	"./icons/dynamic.svg": 43350,
	"./icons/edit-box.svg": 43771,
	"./icons/edit.svg": 975,
	"./icons/euro.svg": 11116,
	"./icons/external-link.svg": 839,
	"./icons/eye-off.svg": 59210,
	"./icons/eye.svg": 34426,
	"./icons/fantasticon/icons.css": 97456,
	"./icons/fantasticon/icons.eot": 47979,
	"./icons/fantasticon/icons.woff": 37459,
	"./icons/fantasticon/icons.woff2": 21291,
	"./icons/film.svg": 31357,
	"./icons/filter.svg": 87985,
	"./icons/gift.svg": 66081,
	"./icons/globe.svg": 5938,
	"./icons/hash.svg": 29607,
	"./icons/heart-empty.svg": 2145,
	"./icons/heart-full.svg": 29349,
	"./icons/heart.svg": 49733,
	"./icons/heart_minus.svg": 10240,
	"./icons/heart_plus.svg": 24232,
	"./icons/home.svg": 74174,
	"./icons/hour-glass-end.svg": 5090,
	"./icons/hour-glass-start.svg": 3217,
	"./icons/image.svg": 83922,
	"./icons/images.svg": 61773,
	"./icons/inbox.svg": 8973,
	"./icons/info.svg": 36947,
	"./icons/integration.svg": 40163,
	"./icons/integration2.svg": 84027,
	"./icons/invoice.svg": 98292,
	"./icons/invoice2.svg": 28110,
	"./icons/invoice3.svg": 40191,
	"./icons/key.svg": 97000,
	"./icons/kiosk-disabled.svg": 22361,
	"./icons/kiosk.svg": 15684,
	"./icons/kitchen.svg": 23993,
	"./icons/kitchen2.svg": 90729,
	"./icons/layers.svg": 63465,
	"./icons/link.svg": 31119,
	"./icons/list.svg": 60071,
	"./icons/lock.svg": 45482,
	"./icons/log-out.svg": 40852,
	"./icons/mail.svg": 59814,
	"./icons/map-pin.svg": 35789,
	"./icons/mapg.svg": 81802,
	"./icons/mapw.svg": 4602,
	"./icons/markpaid.svg": 69878,
	"./icons/menu-bars.svg": 33493,
	"./icons/menu-gray.svg": 39226,
	"./icons/menu-white.svg": 77374,
	"./icons/menu.svg": 72434,
	"./icons/message-circle.svg": 63493,
	"./icons/mimo1.svg": 68130,
	"./icons/mimo2.svg": 39025,
	"./icons/minus.svg": 48441,
	"./icons/monitor.svg": 17871,
	"./icons/more-vertical.svg": 71095,
	"./icons/move.svg": 67680,
	"./icons/package.svg": 9453,
	"./icons/paperclip.svg": 19081,
	"./icons/percent.svg": 87594,
	"./icons/phone.svg": 16345,
	"./icons/picture.svg": 75887,
	"./icons/picture2.svg": 73375,
	"./icons/picture3.svg": 42382,
	"./icons/plus-square.svg": 5777,
	"./icons/plus.svg": 24491,
	"./icons/print-disabled.svg": 30209,
	"./icons/print-enabled.svg": 168,
	"./icons/printer.svg": 89049,
	"./icons/qr.svg": 86690,
	"./icons/refresh.svg": 32304,
	"./icons/robot-ai.svg": 95952,
	"./icons/save.svg": 44660,
	"./icons/scale.svg": 30927,
	"./icons/scan.svg": 30124,
	"./icons/search.svg": 64343,
	"./icons/service.svg": 61712,
	"./icons/service2.svg": 56098,
	"./icons/settings.svg": 20716,
	"./icons/shield.svg": 66164,
	"./icons/shopping-cart.svg": 5302,
	"./icons/shopping_bag.svg": 29076,
	"./icons/statistic.svg": 28195,
	"./icons/table.svg": 1145,
	"./icons/table_bar.svg": 90195,
	"./icons/tablet.svg": 73495,
	"./icons/terminal.svg": 35311,
	"./icons/timer-start.svg": 65161,
	"./icons/transfer.svg": 97422,
	"./icons/trash.svg": 36891,
	"./icons/upload.svg": 50600,
	"./icons/user.svg": 10698,
	"./icons/users.svg": 73557,
	"./icons/warning.svg": 42865,
	"./icons/website-disabled.svg": 15731,
	"./icons/website.svg": 9386,
	"./icons/website2.svg": 91700,
	"./icons/x-circle.svg": 5046,
	"./icons/x.svg": 99897,
	"./icons/zap.svg": 80656,
	"./illustrations/secure.svg": 37005,
	"./images/qr1.svg": 20999,
	"./images/qr2.png": 12906,
	"./images/qr3.png": 68115,
	"./images/qr4.png": 68156,
	"./images/qr5.png": 97573,
	"./logo.png": 33153,
	"./logo.svg": 63935,
	"./logo2.svg": 87727,
	"./logo3.svg": 51326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;